import { initState as landing } from './landing/initState';

export const templateInitStates = { landing };
